/* Provenance statuses and small math helpers for the versioned rate settings. DB % and påslag % are different numbers. */
export const PROV = {
  bekreftet: { label: "Bekreftet", cls: "v-ok", hint: "Bekreftet kilde (Skarpenord-prisliste)" },
  historisk: { label: "Historisk – ubekreftet", cls: "v-assumed", hint: "Fra historisk kalkylemal/sak. Ikke bekreftet som gjeldende." },
  demo: { label: "Demo / antakelse", cls: "bg-[hsl(268_35%_48%/0.12)] text-[hsl(268_35%_36%)]", hint: "Demoverdi eller antakelse – må byttes ut med bekreftet verdi." },
  uavklart: { label: "Uavklart", cls: "bg-black/[0.06] text-foreground/70", hint: "Ikke avklart med LOS." },
};
export const PROV_OPTIONS = Object.entries(PROV).map(([k, v]) => [k, v.label]);

export const BILLING = { pris: "Fast pris", pr_time: "Pr. time", etter_regning: "Etter regning", note: "Se merknad", uavklart: "Uavklart" };

export function dbPct(cost, price) {
  if (cost == null || price == null || !price) return null;
  return ((price - cost) / price) * 100;
}
export function markupPct(cost, price) {
  if (cost == null || price == null || !cost) return null;
  return ((price - cost) / cost) * 100;
}
export function priceFrom(cost, method, value) {
  if (cost == null || value == null) return null;
  if (method === "paslag") return cost * (1 + value / 100);
  return value < 100 ? cost / (1 - value / 100) : null;
}

export function setIn(obj, path, value) {
  if (!path.length) return value;
  const [head, ...rest] = path;
  if (Array.isArray(obj)) {
    const copy = obj.slice();
    copy[head] = setIn(obj[head], rest, value);
    return copy;
  }
  return { ...(obj || {}), [head]: setIn((obj || {})[head], rest, value) };
}

export function num(v) {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(String(v).replace(",", ".").replace(/\s/g, ""));
  return Number.isNaN(n) ? NaN : n;
}
